module.exports = __webpack_public_path__ + "static/media/octes8h_5.280a0293.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/octes/octes8h_5.svg
// module id = 750
// module chunks = 0